import { gql } from '@apollo/client';

export default gql`
  mutation DeleteSelectedProductQuestion($selectedProductQuestionId: Int!) {
    deleteSelectedProductQuestionById(input: { id: $selectedProductQuestionId }) {
      selectedProductQuestion {
        id
        questionId
      }
    }
  }
`;
